import React, { useState, useEffect } from "react";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import banner from "../assets/imagen.jpg";
import { Container, Row, Col, Image, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../components/asistencia.css";
import SocialBar from "../components/SocialBar";
import logoFacach from "../assets/isotipo.png";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';


const API_URL = "https://facach.coop.hn/api";

// Fallback estático
const FALLBACK = [
  { id: 1, titulo: "Área de Planificación", detalle: "Orienta a las cooperativas en la definición de su rumbo estratégico y operativo.", bullets: [{ label: "Planes Estratégicos", descripcion: "Definen prioridades y metas a mediano y largo plazo." }, { label: "Planes Operativos", descripcion: "Convierten la estrategia en actividades ejecutables." }, { label: "Elaboración de presupuesto", descripcion: "Establece proyecciones para la ejecución de los planes." }, { label: "Planes Empresariales", descripcion: "Facilitan el seguimiento anual de metas institucionales." }] },
  { id: 2, titulo: "Área de Desarrollo Organizacional", detalle: "Fortalece la estructura, las capacidades y la cultura interna de las cooperativas.", bullets: [{ label: "Diagnósticos internos", descripcion: "Análisis para identificar oportunidades de mejora." }, { label: "Capacitación a áreas internas", descripcion: "Desarrolla competencias del personal." }, { label: "Asesoría áreas de procesos", descripcion: "Acompaña la implementación de mejoras." }, { label: "Asesoría áreas internas", descripcion: "Revisión y rediseño de procesos clave." }] },
  { id: 3, titulo: "Gestión Financiera", detalle: "Provee análisis y herramientas que fortalecen la salud financiera de la cooperativa.", bullets: [{ label: "Estudios de factibilidad", descripcion: "Evaluar los proyectos de las cooperativas." }, { label: "Análisis de tasas", descripcion: "Identificar la estructura más recomendada de tasas." }, { label: "Métodos de crédito", descripcion: "Recomendaciones en políticas y metodologías crediticias." }, { label: "Diagnósticos financieros", descripcion: "Detectar fortalezas y vulnerabilidades financieras." }] },
  { id: 4, titulo: "Herramientas Administrativas", detalle: "Entregar instrumentos y normas prácticas para la implementación de marcos normativos.", bullets: [{ label: "Manuales y Reglamentos", descripcion: "Formalizar los procedimientos en base a normas." }, { label: "Asesoría en Gobernabilidad", descripcion: "Fortalecer estructuras de gobierno cooperativo." }, { label: "Cumplimiento y Riesgo", descripcion: "Apoyo con las normas para mitigar riesgos." }, { label: "Herramientas DGRV", descripcion: "Impulsa la digitalización de las cooperativas." }] },
  { id: 5, titulo: "Supervisión y Regulación", detalle: "Acompañar a las cooperativas en el cumplimiento normativo del CONSUCOOP.", bullets: [{ label: "Asesoría técnica en Normativas", descripcion: "Orientación en la aplicación de Normas." }, { label: "Acompañamiento en planes de trabajo", descripcion: "Apoyar la ejecución ordenada de acciones." }, { label: "Planes de adecuación", descripcion: "Diseñar planes conforme a lo solicitado." }, { label: "Planes de estabilización", descripcion: "Informes para la recuperación financiera." }] },
  { id: 6, titulo: "Auditoría Interna Tercerizada", detalle: "Ofrece seguimiento al plan de trabajo de acuerdo con la norma vigente.", bullets: [{ label: "Asesoría y desarrollo", descripcion: "Respuestas para la gestión efectiva de control interno." }, { label: "Planes de trabajo", descripcion: "Definidos de acuerdo con norma vigente del CONSUCOOP." }, { label: "Visitas presenciales y virtuales", descripcion: "Revisiones in situ y remotas para verificar control interno." }, { label: "Elaboración de informes", descripcion: "Presentar hallazgos y recomendaciones conforme a norma." }] },
];

function ServicioCard({ srv }) {
  const [expanded, setExpanded] = useState(false);
  const [activeBullet, setActiveBullet] = useState(null);

  const handleBulletClick = (label) => {
    setActiveBullet(activeBullet === label ? null : label);
  };

  const bullets = Array.isArray(srv.bullets) ? srv.bullets : [];

  return (
    <Card className="at-card h-100">
      <Card.Header className="at-card-header d-flex align-items-center">
        <Image src={logoFacach} alt="FACACH" className="at-logo me-2" loading="lazy" />
        <span className="at-title">{srv.titulo}</span>
      </Card.Header>
      <Card.Body className="at-card-body">
        <div className="at-detalle"><p className="mb-0">{srv.detalle}</p></div>

        {expanded && bullets.length > 0 && (
          <ul className="at-list mt-3">
            {bullets.map((b, i) => {
              const label = typeof b === 'string' ? b : b.label;
              const desc = typeof b === 'string' ? '' : b.descripcion;
              return (
                <li key={i}
                  className={`at-list-item ${activeBullet === label ? "at-list-item--active" : ""}`}
                  onClick={() => handleBulletClick(label)}
                  role="button" tabIndex={0}
                  onKeyDown={e => e.key === "Enter" && handleBulletClick(label)}
                >
                  <div className="at-list-item-header">
                    <span aria-hidden="true" className="at-bullet"></span>
                    <span className="at-bullet-text">{label}</span>
                    <span className="at-bullet-chevron">{activeBullet === label ? "▲" : "▼"}</span>
                  </div>
                  {activeBullet === label && desc && (
                    <div className="at-bullet-desc">{desc}</div>
                  )}
                </li>
              );
            })}
          </ul>
        )}

        <button className="at-toggle-btn mt-3" onClick={() => { setExpanded(!expanded); if (expanded) setActiveBullet(null); }}>
          {expanded ? "Ver menos ▲" : "Ver más ▼"}
        </button>
      </Card.Body>
    </Card>
  );
}

const Asistencia = () => {

const { settings } = useSiteSettings();
    const bannerSrc = settings.banner_image
      ? `https://facach.coop.hn${settings.banner_image}`
      : fallbackBanner;

  const [servicios, setServicios] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res = await fetch(`${API_URL}/technical-services`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data?.length > 0) setServicios(json.data);
      } catch (err) {
        console.error("Error cargando servicios técnicos:", err.message);
      } finally { setLoading(false); }
    };
    fetch_();
  }, []);

  return (
    <Container fluid className="p-0 asistencia-page">
      <NavbarFacach />
      <div className="banner-wrapper">
        <Image src={bannerSrc} alt="Asistencia Técnica - FACACH" fluid className="banner-image" />
        <div className="banner-overlay" style={{ pointerEvents: "none" }}>
          <h1 className="banner-title">ASISTENCIA TÉCNICA</h1>
        </div>
        
      </div>


      <Container className="mt-2" style={{ position: "relative", zIndex: 2 }}>
        <Row className="justify-content-center">
          <Col xs={12} className="text-center">
            <h2 className="at-section-title">Nuestros servicios</h2>
            <p className="at-section-subtitle">
              Se ofrecen servicios técnicos especializados orientados a cinco componentes
              esenciales para el desarrollo integral de las cooperativas: planificación, desarrollo
              organizacional, gestión financiera, herramientas administrativas y financieras, así
              como supervisión y regulación. De manera complementaria, se dispone de auditoría
              interna tercerizada, enfocada en fortalecer la transparencia y control interno.
              Estos servicios están orientados a impulsar estrategias y proyectos cooperativos,
              apoyando la toma de decisiones y contribuyendo a la sostenibilidad y competitividad
              del sector.
            </p>
          </Col>
        </Row>

        {loading ? (
          <div className="text-center py-5"><span className="at-section-title" style={{ fontSize: 14 }}>Cargando…</span></div>
        ) : (
          <div className="at-grid-bg" style={{ position: "relative", zIndex: 2 }}>
            <Row className="g-3 g-md-4 at-cards-row">
              {servicios.map(srv => (
                <Col key={srv.id} xs={12} md={6} lg={4}>
                  <ServicioCard srv={srv} />
                </Col>
              ))}
            </Row>
          </div>
        )}

        <div className="boton-centro my-4">
          <Button variant="primary" as={Link} to="/contacto_at" className="cta-btn">
            Contáctanos para obtener más información
          </Button>
        </div>
        <div className="boton-centro my-3">
          <Button as="a" href="/documentos/catalogo.pdf" target="_blank" rel="noopener noreferrer"
            variant="link" className="producto-vermas-link mt-auto p-0"
            style={{ color: "#252A58", textAlign: "center", opacity: "0.90" }}>
            Haz clic para ver nuestro Catálogo 
          </Button>
        </div>
        <SocialBar position="right" top="35%" size={42} rounded={true} />
      </Container>
      <FooterFacach />
    </Container>
  );
};

export default Asistencia;